import React from "react";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  onClick: (event: any) => void;
}
const Button: React.FC<IProps> = ({ title, onClick, ...props }) => (
  <button onClick={onClick} {...props}>
    {title}
  </button>
);

export default Button;
